module.exports = __webpack_public_path__ + "img/存储卡录像回放工具.bd2656e2.png";